<template>
  <Landing v-if="!isAuthenticated" />
  <MainAfterLogin v-else-if="isAuthenticated && me" />
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import Landing from '@/components/main/Landing.vue'
import MainAfterLogin from '@/components/main/MainAfterLogin.vue'

export default {
  components: {
    Landing,
    MainAfterLogin,
  },
  data() {
    return {}
  },
  created() {
    _meta({
      og: {
        title: '바이나우 BUYNOW',
        description: '어제 매출 오늘 받아보는 선정산',
      },
    })
  },
  computed: {
    ...mapGetters('auth', ['isAuthenticated']),
    ...mapState('auth', ['me']),
  },
  watch: {},
  methods: {},
}
</script>
